
import { Button } from "@/shared/ui/button";
import { Calendar } from "@/shared/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/shared/ui/popover";
import { Label } from "@/shared/ui/label";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { cn } from "@/shared/lib/utils";

interface DatePickerFieldProps {
  label: string;
  sublabel: string;
  date: Date | null;
  onDateChange: (date: Date | null) => void;
}

export function DatePickerField({ label, sublabel, date, onDateChange }: DatePickerFieldProps) {
  const formatDate = (date: Date | null) => {
    if (!date) return "";
    return format(date, "dd/MM/yyyy", { locale: ptBR });
  };

  return (
    <div className="w-[320px]">
      <Label className="text-white/60 text-sm">{sublabel}</Label>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "w-full justify-start text-left font-normal bg-[#1A1A1A] border-[#333333] text-white h-10 mt-2",
              !date && "text-white/60"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? formatDate(date) : "--/--/----"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-[#1A1A1A] border-[#333333]" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={onDateChange}
            initialFocus
            fromDate={new Date()}
            classNames={{
              day_selected: "bg-[#C1174F] text-white hover:bg-[#C1174F] focus:bg-[#C1174F]",
            }}
            className="bg-[#1A1A1A] text-white"
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
